import { LoginComponent } from "@auth/login/login.component";
import { Routes } from "@angular/router";
import { LoginGuard } from "./authorization/login.guard";
import { ComprasGuard } from "./compras/compras.guard";
import { DirectorGuard } from "./director/director.guard";
import { ConfiguracionGuard } from "./configuracion/configuracion.guard";
import { AuthGuard } from "./authorization/authorize.guard";
import { PeritoGuard } from "./perito/perito.guard";
import { HomeComponent } from "./home/home.component";
import { RecepcionGuard } from "./recepcion/recepcion.guard";
import { AsistenciaGuard } from "./asistencia/asistencia.guard";
import { AsistenciaCompraGuard } from "./asistencia-compra/asistencia-compra.guard";
import { VerificateComponent } from "./verificate/verificate.component";
import { AdminLayoutComponent } from "@shared/admin-layout/admin-layout.component";
import { ConfirmacionOferenteGuard } from "./confirmacion/confirmacion.guard";
import { PresentacionGuard } from "@presentacion/presentacion.guard";

export const AppRoutes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "configuracion",
        loadChildren: () =>
          import("./configuracion/configuracion.module").then(
            (m) => m.ConfiguracionModule
          ),
        canActivate: [AuthGuard, ConfiguracionGuard],
      },
      {
        path: "seguridad",
        loadChildren: () =>
          import("./seguridad/seguridad.module").then((t) => t.SeguridadModule),
        canActivate: [AuthGuard, ConfiguracionGuard],
      },
      {
        path: "compras",
        loadChildren: () =>
          import("./compras/compras.module").then((t) => t.ComprasModule),
        canActivate: [AuthGuard, ComprasGuard],
      },
      {
        path: "director",
        loadChildren: () =>
          import("./director/director.module").then((t) => t.DirectorModule),
        canActivate: [AuthGuard, DirectorGuard],
      },
      {
        path: "perito",
        loadChildren: () =>
          import("./perito/perito.module").then((t) => t.PeritoModule),
        canActivate: [AuthGuard, PeritoGuard],
      },
      {
        path: "recepcion",
        loadChildren: () =>
          import("./recepcion/recepcion.module").then((t) => t.RecepcionModule),
        canActivate: [AuthGuard, RecepcionGuard],
      },
      {
        path: "asistencia-compra",
        loadChildren: () =>
          import("./asistencia-compra/asistencia-compra.module").then(
            (t) => t.AsistenciaCompraModule
          ),
        canActivate: [AuthGuard, AsistenciaCompraGuard],
      },
      {
        path: "asistencia",
        loadChildren: () =>
          import("./asistencia/asistencia.module").then(
            (t) => t.AsistenciaModule
          ),
        canActivate: [AuthGuard, AsistenciaGuard],
      },
      { path: "verificate", component: VerificateComponent },
      {
        path: "confirmacion-asistencia",
        loadChildren: () =>
          import("./confirmacion/confirmacion.module").then(
            (t) => t.ConfirmacionOferenteModule
          ),
        canActivate: [AuthGuard, ConfirmacionOferenteGuard],
      },
    ],
  },
  {
    path: "participante",
    loadChildren: () =>
      import("./participante/participante.module").then(
        (m) => m.ParticipanteModule
      ),
  },
  { path: "login", component: LoginComponent, canActivate: [LoginGuard] },
  { path: "home", component: HomeComponent, canActivate: [LoginGuard] },
  {
    path: "presentacion",
    loadChildren: () =>
      import("./presentacion/presentacion.module").then(
        (t) => t.PresentacionModule
      ),
    canActivate: [AuthGuard, PresentacionGuard],
  },
  {
    path: "ganadores-sorteo",
    loadChildren: () =>
      import("./ganadores-sorteo/ganadores-sorteo.module").then(
        (t) => t.GanadoresSorteoModule
      ),
  },
  {
    path: "**",
    redirectTo: "home",
  },
];
